<template>
  <router-link :to="{ name: 'page1' }" class="index">

    <div class="slogan">
      <img
        class="animated bounceInLeft"
        src="@/assets/img/pc/start.png"
        alt=""
      />
      <div>
        <img
          class="animated bounceInLeft"
          src="@/assets/img/pc/start-btn.png"
          alt=""
        />
      </div>
    </div>

    <div class="footer font12">
      未经日浩同意，不得转载本网站之所有招聘信息 日浩版权所有 ©

      <span style="font-family: Arial">2005- {{ year }} </span>
    </div>
  </router-link>
</template>

<script>
import { isMobile } from "@/assets/js/index";

export default {
  name: "welcome",
  components: {},
  data() {
    return {
      year: new Date().getFullYear(),
    }
  },
  mounted() {
    if (isMobile()) {
      this.$router.replace({ name: "mobile" });
    }
  },
};
</script>
<style scoped>
.index {
  background: url("../../assets/img/pc/start-bg.jpg") no-repeat top/100% 100%;
  display: flex;
  flex-flow: column;
  width: 100vw;
  height: 100vh;
  /* justify-content:center;
    align-items:center; */
}
.logo {
  text-align: left;
  height: 60px;
  width: 180px;
  margin-left: 0.5rem;
}
.slogan {
  width: 5rem;
  margin-left: 1rem;
  text-align: right;
  display: flex;
  flex-flow: column;
  flex: 1;
  justify-content: center;
}
.footer {
  display: block;
  width: 100vw;
  text-align: center;
  line-height: 0.1rem;
  padding: 0.2rem 2.5%;
  box-sizing: border-box;
  color: #000;
  position: absolute;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0);
  margin-top: 0;
  font-size: 0.1rem;
}
</style>
